import { Auth } from '../../services';
const Expandable = require('../ui/expandable');
const Alert = require('../ui/alert');

const markup = `<db:passwordreset>
	<form data-id='getCodeForm'>
		<div>Send me a reset code:</div>
		<div>
			<label>Username</label>
			<input type='text' data-id='username' data-property='value' />
		</div>
		<div>
			<input type='submit' value='Send Code' />
		</div>
	</form>

	<hr />

	<form data-id='resetPasswordForm'>
		<div>I have my reset code:</div>
		<div>
			<label>Username</label>
			<input type='text' data-id='usernameForCode' data-property='value' />
		</div>
		<div>
			<label>Code</label>
			<input type='text' data-id='code' data-property='value' />
		</div>
		<div>
			<label>New Password</label>
			<input type='password' data-id='password' data-property='value' />
		</div>
		<div>
			<input type='submit' value='Reset' />
		</div>
	</form>
</db:passwordreset>`;

export default DomClass(markup, function() {
	var _t = this;

	this.__dom.getCodeForm.onsubmit = () => {
		Auth.forgotPassword(_t.username).then(() => {
				_t.usernameForCode = _t.username;
				_t.username = '';
				new Alert({message: "Your reset code has been sent."});
			})
			.catch(error => new Alert({message: error.message}))
		;
		return false;
	};

	this.__dom.resetPasswordForm.onsubmit = function() {
		Auth.forgotPasswordSubmit(_t.usernameForCode, _t.code, _t.password).then(() => {
				_t.usernameForCode = '';
				_t.code = '';	
				_t.password = '';
				new Alert({message: `
					<h4>Password reset.</h4>
					<p>You can sign in with it now.</p>
				`});
				on(this, 'complete').fire();
			})
			.catch(error => new Alert({message: error.message}))
		;
		return false;
	}
});
